module.exports = __webpack_public_path__ + "img/logo65anosBranca.35acb026.svg";